import React, { useState } from "react";
import ResetPasswordComponent from "./resetPasswordComponent";
import { BusinessUser } from "../../services";
import Utils from "../../utility";
import UserService from "../../services/businessUser";
import { failureMessageConstant } from "../../constants";

const ResetPassword = () => {
  const [states, setStates] = useState({
    showSuccessMsg: false,
    emailError: "",
    isLoading: false
  });

  const updateState = (name, value) => {
    setStates((prevState) => ({ ...prevState, [name]: value }));
  };

  /**
   * Handles the submission of data for password reset.
   * @param {object} data - The data containing the email.
   */
  const submitHandler = async (data) => {
    try {
      const { email } = data;
      const userEmail = email.toLowerCase();
      updateState("isLoading", true);
      const [error, businessResponse] = await Utils.parseResponse(
        new UserService().checkBusinessExists({ email: userEmail })
      );
      if (error || !businessResponse) {
        if (error?.response?.data.message) {
          updateState(
            "emailError",
            failureMessageConstant.EMAIL_NOT_REGISTERED
          );
        } else {
          Utils.failureToastMessage(
            failureMessageConstant.SOMETHING_WENT_WRONG
          );
        }
        return;
      }
      await new BusinessUser().resetPassword({ email: userEmail }); // Reset the password for the email
      updateState("showSuccessMsg", true); // Show success message
    } catch (error) {
      console.error(error);
    } finally {
      updateState("isLoading", false);
    }
  };
  return (
    <ResetPasswordComponent
      states={states}
      functionObj={{ submitHandler, updateState }}
    />
  );
};

export default ResetPassword;
